import { render } from "./TheUtilityBar.vue?vue&type=template&id=2a89f722&scoped=true"
import script from "./TheUtilityBar.vue?vue&type=script&lang=js"
export * from "./TheUtilityBar.vue?vue&type=script&lang=js"

import "./TheUtilityBar.vue?vue&type=style&index=0&id=2a89f722&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a89f722"]])

export default __exports__